import { Button } from "primereact/button";
import CreateInvoiceTop from "./create-inv-top";
import { useState } from "react";
import SelectPaymentInvoice from "./select-payment-invoice";
import InvoicePayment from "./invoice-payment";
import { RadioButton } from "primereact/radiobutton";
import { useTranslation } from "react-i18next";
import { InputText } from 'primereact/inputtext';
import '../../assests/css/common/responsive-ui.css'


const PaymentProcess = (props: any) => {
  const { t } = useTranslation();

  const [paymentModeId, setPaymentModeId] = useState<number>();
  const [paymentInvoiceId, setPaymentInvoiceId] = useState<number>();
  const [displayOtherPaymentOptions, setDisplayOtherPaymentOptions] = useState<Boolean>(false);
  const [selectedOtherPaymentCode, setSelectedOtherPaymentCode] = useState<string>("UPI");
  const [bankrefno, setBankRefNo] = useState("");
  const [orderStatus, setOrderStatus] = useState("Success");

  const handleGetPayment = async (event: React.MouseEvent<HTMLButtonElement>) => {
    try {
      if (paymentModeId == 2) {
        let othersPaymentData = {
          bankRefNo : bankrefno,
          orderStatus : orderStatus,
          paymentMode : selectedOtherPaymentCode,
          orderInvoiceID: paymentInvoiceId
        }
        props.handleOtherPaymentMode(othersPaymentData)
      }
      else{
        props.runOrderPayment(event, paymentInvoiceId, paymentModeId);
      }
      props.runHideDialog();
    }
    catch {
      console.log("#Error at Payment Process....!")
    }
  };

  let otherPaymentModes = [
    {
      id: "1",
      mode: "Credit Card",
      code: "Credit Card",
      isSelected: false,
    },
    {
      id: "2",
      mode: "Debit Card",
      code: "Debit Card",
      isSelected: false,
    },
    {
      id: "3",
      mode: "Internet Banking",
      code: "Internet Banking",
      isSelected: false,
    },
    {
      id: "4",
      mode: "UPI",
      code: "UPI",
      isSelected: false,
    }
  ];

  let orderStatusData = [
    {
      id: "1",
      mode: "Success",
      code: "Success",
      modeImage: "",
      isSelected: false,
    },
    {
      id: "2",
      mode: "Failure",
      code: "Failure",
      modeImage: "",
      isSelected: false,
    }
  ];

  const handleOrderStatus = (e: any, value: any) => {
    setOrderStatus(value?.code);
  }

  const saveOtherPaymentMode = (e: any, value: any) => {
    setSelectedOtherPaymentCode(value?.code);
  };

  const handleBankRefNo = (value: any) => {
    setBankRefNo(value)
  };

  return (
    <>
      <div className="flex flex-column border-1 surface-border box-shadow-none m-0">
        <CreateInvoiceTop orderData={props.OrderData} />
        <div className="pl-3 mb-3">
          <SelectPaymentInvoice orderData={props.OrderData} updatePaymentInvoiceId={setPaymentInvoiceId} /><br />
        </div>
        <div className="pl-3 mb-3">
          <p>Select payment mode: </p>
          {/* set displayOthersPayment to false because we don't need it any more*/}
          <InvoicePayment updatePaymentId={setPaymentModeId} displayOthersPayment={false} setOtherPaymentData={setDisplayOtherPaymentOptions}/>
        </div>
        <div className="pl-3 mb-3">
          {
            displayOtherPaymentOptions &&
            <div>
              <div className="mt-4 align-items-left align-items-center">
                {/* use {t("bank_reference_num")} */}
                <label htmlFor="bank_reference_num">{"Bank Reference Number: "}</label>
                <span className="ml-2">
                  <InputText className="bank-refer-inputtext" type="text" name="Bank Reference Number" id="bank_reference_num" onChange={(e) => handleBankRefNo(e.target.value)} value={bankrefno} placeholder={"Enter Bank ref number"} />
                </span>
              </div>
              <div className="mt-4 flex flex-wrap">
                {/* use {t("order_status")} */}
                <label>
                  {"Order Status: "}
                </label>
                {orderStatusData.map((category) => {
                  return (
                    <div key={category.id} className="ml-3 flex align-items-left">
                      <RadioButton
                        inputId={category.id}
                        name="category"
                        value={category}
                        onChange={(e) => handleOrderStatus(e, e.value)}
                        checked={orderStatus === category.code}
                      />
                      <label htmlFor={category.id} className="ml-2 font-medium text-nowrap">
                        {category.mode}
                      </label>
                    </div>
                  );
                })}
              </div>
              <div className="flex flex-wrap mt-4">
                {/* use {t("other_payment_mode")} */}
                <label>
                  {"Payment mode: "}
                </label>
                {otherPaymentModes.map((category) => {
                  return (
                    <div key={category.id} className="ml-3 flex align-items-left">
                      <RadioButton
                        inputId={category.id}
                        name="category"
                        value={category}
                        onChange={(e) => saveOtherPaymentMode(e, e.value)}
                        checked={selectedOtherPaymentCode === category.code}
                      />
                      <label htmlFor={category.id} className="ml-2 font-medium text-nowrap">
                        {category.mode}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          }
        </div>
      </div>
      <div className="flex justify-content-end flex-wrap mt-2">
      <Button label="Close" className="border-round mt-2 responsive-button ml-2" onClick={props.runHideDialog} style={{ float: 'right', width: "20%", textAlign: 'center' }} severity="warning" />
      <Button label="Proceed to payment" className="border-round mt-2 ml-2 responsive-button" onClick={(e) => { handleGetPayment(e) }} style={{ float: 'right', width: "30%", textAlign: 'center' }} severity="success" />
     
      </div>
    </>
  );
};

export default PaymentProcess;